import React from 'react';
import { ReactComponent as ToreadCheck } from 'assets/icons/toread-check.svg';
import { ReactComponent as ToreadUncheck } from 'assets/icons/toread-uncheck.svg';

type ToreadIconProps = {
	checked: boolean;
	size?: number;
};

export const ToreadIcon = ({ checked, size = 18 }: ToreadIconProps) => {
	return checked ? <ToreadCheck width={size} height={size} /> : <ToreadUncheck width={size} height={size} />;
};
